import * as React from 'react';
import { ArticleHeading1, ArticleParagraph1, IconFavoritesOff16 } from '@cian/ui-kit';
import { Link } from '../../../Link';
import * as style from './EmptyReviewsTeaser.css';
import { createArrayFromTo } from '../../../../utils/arrays';
import { ReviewsFooter } from '../ManyReviewsTeaser/ReviewsFooter';

const STARS_COUNT = 5;
const STARS = createArrayFromTo(1, STARS_COUNT);

export interface IEmptyReviewsTeaserProps {
  name: string;
  fullUrl: string;
  newReviewLinkClick: () => void;
  isQuestionsFeatureEnabled: boolean;
}

export const EmptyReviewsTeaser: React.FC<IEmptyReviewsTeaserProps> = ({
  name,
  fullUrl,
  newReviewLinkClick,
  isQuestionsFeatureEnabled,
}) => {
  return (
    <div className={style['container']}>
      <ArticleHeading1>
        Ваш отзыв {isQuestionsFeatureEnabled && 'или вопрос'} о {name} <br /> будет первым
      </ArticleHeading1>
      <ArticleParagraph1>Оцените ЖК — помогите другим с выбором</ArticleParagraph1>

      {isQuestionsFeatureEnabled && (
        <ReviewsFooter fullUrl={fullUrl} reviewsCountText={''} showReviewsLinkClick={newReviewLinkClick} />
      )}

      {!isQuestionsFeatureEnabled && (
        <div className={style['stars']}>
          <Link
            url={`${fullUrl}otzyvy/#new-review`}
            target="blank"
            data-testid="NewReviewLinkClick"
            onClick={newReviewLinkClick}
          >
            <ul className={style['list']}>
              {STARS.map(count => (
                <li key={count} className={style['item']}>
                  <IconFavoritesOff16 />
                </li>
              ))}
            </ul>
          </Link>
        </div>
      )}
    </div>
  );
};
